'use client'

import React from 'react'
import { HomeBlock as HomeBlockType, Media as MediaProps } from '@/payload-types'
// import RevealHeading from '@/components/RevealHeading'
// import FramerReveal from '@/components/framer-reveal-component'
import { TypedLocale } from 'payload'
import Image from 'next/image'
import RichText from '@/components/RichText'
import { CMSLink } from '@/components/Link'
import { motion } from 'motion/react'

export const HomeBlock: React.FC<
  HomeBlockType & {
    id?: string
    locale: TypedLocale
  }
> = ({ sections, timeline, heroSection }) => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] as any }
    },
  }

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] as any }
    },
  }

  return (
    <div className="" data-theme="light">
      {/* <div
        className='w-full min-h-screen relative bg-[url("/images/4.webp")] bg-fixed object-cover grid md:grid-cols-2 md:ps-16 px-4 overflow-hidden'
        style={{
          backgroundImage: `url("${(heroSection.image as MediaProps)?.url}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="z-10 absolute inset-0 bg-black opacity-90 w-full h-full"></div>
        <div className="z-10 absolute inset-0 bg-gradient-to-r from-slate-600 via-gray-500 to-slate-400 opacity-30 w-full h-full"></div>
        <div className={`md:ms-16 mx-4 text-white place-self-center rounded-xl z-20`}>
          <RevealHeading>
            <h3 className="silver-large-text text-3xl md:text-7xl">{heroSection.title}</h3>
          </RevealHeading>
          <RevealHeading>
            {heroSection?.description && (
              <RichText
                data={heroSection.description} // Change 'data' to 'content' if that's the prop name your RichText component expects
                enableProse={true}
                className="prose-headings:mb-4"
              />
            )}
          </RevealHeading>
        </div>
      </div> */}

        {sections?.map((section: any, index: number) => (
          <motion.section
            key={index}
            className="w-full min-h-[80vh] relative flex flex-col md:grid md:grid-cols-2 bg-white overflow-hidden max-w-full"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={containerVariants}
          >
            {section.layout === 'imageLeft' ? (
              <>
                <motion.div
                  className="w-full h-64 md:h-full relative min-h-[300px] flex flex-col order-2 md:order-1 justify-center items-center"
                  style={{
                    aspectRatio: Math.min(section.image.width / section.image.height, 2),
                  }}
                  variants={imageVariants}
                >
                  <Image
                    src={section.image.url}
                    alt={section.title}
                    fill
                    sizes="(max-width: 768px) 100vw, 50vw"
                    className="object-contain object-center"
                    priority={index === 0}
                  />
                </motion.div>
                <motion.div 
                  className="w-full px-4 md:pe-4 md:ps-8 py-8 flex flex-col justify-center order-1 md:order-2 overflow-hidden" 
                  variants={containerVariants}
                >
                  <motion.h2 
                    className="text-2xl md:text-5xl lg:text-7xl font-bold mb-6 break-words text-center md:text-left"
                    variants={itemVariants}
                  >
                    {section.title}
                  </motion.h2>
                  <motion.div 
                    className="mb-8 overflow-hidden"
                    variants={itemVariants}
                  >
                    {section.content && (
                      <div className="break-words overflow-wrap-anywhere">
                        <RichText data={section.content} className='prose-p:text-lg md:prose-p:text-xl' enableProse={true} />
                      </div>
                    )}
                    
                    {section.enableButtons && (
                      <motion.div 
                        className="mt-6 flex flex-wrap items-center gap-4 md:mt-8"
                        variants={itemVariants}
                      >
                        {(section.links || []).map((link, i) => (
                          <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ 
                              opacity: 1, 
                              y: 0,
                              transition: { 
                                duration: 0.4, 
                                delay: 0.3 + (i * 0.1),
                                ease: [0.22, 1, 0.36, 1]
                              }
                            }}
                            viewport={{ once: true }}
                          >
                            <CMSLink {...link.link} />
                          </motion.div>
                        ))}
                      </motion.div>
                    )}
                  </motion.div>
                </motion.div>
              </>
            ) : (
              <>
                <motion.div 
                  className="w-full px-4 md:pe-4 md:ps-8 py-8 flex flex-col justify-center overflow-hidden"
                  variants={containerVariants}
                >
                  <motion.h2 
                    className="text-2xl md:text-5xl lg:text-7xl font-bold mb-6 break-words text-center md:text-left"
                    variants={itemVariants}
                  >
                    {section.title}
                  </motion.h2>
                  <motion.div 
                    className="mb-8 overflow-hidden"
                    variants={itemVariants}
                  >
                    {section.content && (
                      <div className="break-words overflow-wrap-anywhere">
                        <RichText data={section.content} className='prose-p:text-lg md:prose-p:text-xl' enableProse={true} />
                      </div>
                    )}
                     
                    {section.enableButtons && section.links && (
                      <motion.div 
                        className="mt-6 flex  flex-wrap flex-row items-center gap-4 md:mt-8"
                        variants={itemVariants}
                      >
                        {(section.links || []).map((link, i) => (
                          <motion.div
                            key={i}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ 
                              opacity: 1, 
                              y: 0,
                              transition: { 
                                duration: 0.4, 
                                delay: 0.3 + (i * 0.1),
                                ease: [0.22, 1, 0.36, 1]
                              }
                            }}
                            viewport={{ once: true }}
                          >
                            <CMSLink {...link.link} />
                          </motion.div>
                        ))}
                      </motion.div>
                    )}
                  </motion.div>
                </motion.div>
                <motion.div
                  className="w-full h-64 md:h-full relative min-h-[300px] flex justify-center items-center"
                  style={{
                    aspectRatio: Math.min(section.image.width / section.image.height, 2),
                  }}
                  variants={imageVariants}
                >
                  <Image
                    src={section.image.url}
                    alt={section.title}
                    fill
                    sizes="(max-width: 768px) 100vw, 50vw"
                    className="object-contain object-center"
                    priority={index === 0}
                  />
                </motion.div>
              </>
            )}
          </motion.section>
        ))}
  

      <Timeline content={timeline} />
    </div>
  )
}

const TimelineItem = ({ title, content, isLeft, index }: any) => {
  const slideDirection = isLeft ? -40 : 40;
  
  return (
    <motion.div 
      className={`grid md:flex ${isLeft ? 'flex-row' : 'flex-row-reverse'} w-full mb-8`}
      initial={{ opacity: 0, x: slideDirection }}
      whileInView={{ 
        opacity: 1, 
        x: 0,
        transition: { 
          duration: 0.8, 
          delay: 0.2 + (index * 0.1), 
          ease: [0.22, 1, 0.36, 1]
        }
      }}
      viewport={{ once: true, margin: "-50px" }}
    >
      <motion.div 
        className="w-full md:w-5/12"
        initial={{ opacity: 0 }}
        whileInView={{ 
          opacity: 1,
          transition: { duration: 0.6, delay: 0.3 + (index * 0.1) }
        }}
        viewport={{ once: true }}
      >
        <h2 className="silver-large-text my-8">{title}</h2>
      </motion.div>
      <div className="w-2/12 flex justify-center">
        <motion.div 
          className="w-1 bg-white"
          initial={{ height: 0 }}
          whileInView={{ 
            height: "100%",
            transition: { duration: 1, delay: 0.5 }
          }}
          viewport={{ once: true }}
        ></motion.div>
      </div>
      <motion.div 
        className="md:w-5/12 p-4 bg-black bg-opacity-50 rounded-lg w-full"
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ 
          opacity: 1, 
          scale: 1,
          transition: { duration: 0.6, delay: 0.4 + (index * 0.1) }
        }}
        viewport={{ once: true }}
      >
        <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
        {content && (
          <RichText
            data={content}
            enableProse={true}
            className="prose-headings:mb-4"
          />
        )}
      </motion.div>
    </motion.div>
  );
};

const Timeline = ({ content }: any) => (
  <motion.div
    initial={{ opacity: 0 }}
    whileInView={{ 
      opacity: 1,
      transition: { duration: 1 }
    }}
    viewport={{ once: true, margin: "-100px" }}
    data-theme="dark"
    className="w-full min-h-screen overflow-hidden max-w-[100vw] relative bg-[url('/assets/1.webp')] bg-fixed bg-cover bg-no-repeat py-8 md:py-24 px-8 md:px-24"
  >
    <div className="absolute inset-0 bg-black opacity-70"></div>
    <motion.div 
      className="relative z-10 w-full md:max-w-4xl mx-auto"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ 
        opacity: 1, 
        y: 0,
        transition: { duration: 0.8 }
      }}
      viewport={{ once: true }}
    >
      {content?.map((item: any, index: number) => (
        <TimelineItem
          key={index}
          index={index}
          title={item.title}
          content={item.content}
          isLeft={index % 2 === 0}
        />
      ))}
    </motion.div>
  </motion.div>
)
